const isEqual = require("lodash.isequal");

console.log("Frontend Script for Longevity Calculator Loaded!");

document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

window.lgcalculator = [];

let calculators = document.querySelectorAll(".wp-block-lg-blocks-longevity-calculator");

calculators.forEach((calculator, index) => {
    window.lgcalculator[index] = {};
    let thisCalculator = window.lgcalculator[index];
    calculator = $(calculator);

    let totals = calculator.data("totals");
    let tempTotals = {};

    totals.forEach(total => {
        tempTotals[total.slug] = {};
        tempTotals[total.slug].value = parseFloat(total.value);
        tempTotals[total.slug].initial = total.value

        tempTotals[total.slug].proxy = new Proxy(tempTotals[total.slug], {
            set: function (target, key, value) {
                console.log(`${key} set to ${value}`);
                target.counters.forEach((counter) => {
                    counter.text(`$${value.toLocaleString()}`);
                })
                target[key] = value;
            }
        })
    });

    thisCalculator.calculateCompares = () => {
        console.log("calculate Compares Called!");
        console.log(typeof thisCalculator.compares);
        thisCalculator.compares.each(index => {
            let totalA = $(thisCalculator.compares[index]).data("totala");
            let totalB = $(thisCalculator.compares[index]).data("totalb");
            let mode = $(thisCalculator.compares[index]).data("mode");

            let totalAValue = thisCalculator.totals[totalA].value;
            let totalBValue = thisCalculator.totals[totalB].value;

            switch (mode) {
                case "difference": {
                    let result = totalAValue - totalBValue;
                    thisCalculator.compares[index].innerText = `$${result}`;
                    break;
                }
                case "percentDifference": {
                    let result = Math.round(((totalAValue - totalBValue) / totalAValue) * 100);
                    thisCalculator.compares[index].innerText = `${result}%`;
                    break;
                }
            }
        })
    }

    thisCalculator.calculateTotals = () => {
        console.log("Calculate Totals Called!");

        Object.keys(thisCalculator.totals).forEach(key => {
            thisCalculator.totals[key].proxy.value = 0;
        });

        thisCalculator.groups.map((group) => {
            if (isNaN(group.value || group.value === undefined)) {
                return;
            }
            thisCalculator.totals[group.total].proxy.value = thisCalculator.totals[group.total].value + group.value;
        });

        thisCalculator.calculateCompares();
    }

    thisCalculator.calculateGroups = () => {
        console.log("Calculate Groups Called!");

        thisCalculator.groups.forEach(group => {
            group.calculateGroup();
        })
        thisCalculator.calculateTotals();
    }

    totals = tempTotals;

    thisCalculator.totals = totals;
    thisCalculator.calculator = calculator;

    totalCounters = calculator.find(".wp-block-lg-blocks-longevity-calculator-total");

    totalCounters.each(function (cindex) {
        counter = $(this);
        let total = counter.data("total");
        thisCalculator.totals[total].counters = [];
        thisCalculator.totals[total].counters.push(counter);
    })


    thisCalculator.compares = calculator.find(".wp-block-lg-blocks-longevity-calculator-total-compare");

    let groups = calculator.find(".wp-block-lg-blocks-longevity-calculator-group");
    thisCalculator.groups = [];

    groups.each(function (gindex) {
        let group = $(this);
        let type = group.data("type");
        let total = group.data("total");

        thisCalculator.groups[gindex] = {};
        let thisGroup = thisCalculator.groups[gindex];
        thisGroup.value = 0;

        thisGroup.calculateGroup = () => {
            console.log(`calculateGroup for ${gindex} called.`)

            var values = thisGroup.inputs.map(({ value }) => value);
            values = values.filter(value => { return value !== undefined; })
            values = values.filter(value => { return !Number.isNaN(value) })
            if (values.length === 0) {
                values.push(0);
            }
            console.log(values);

            switch (thisGroup.type) {
                case "add": {
                    thisGroup.value = values.reduce((prev, current) => prev + current);
                    break;
                }
                case "subtract": {
                    thisGroup.value = values.reduce((prev, current) => prev - current);
                    break;
                }
                case "multiply-all": {
                    thisGroup.value = values.reduce((prev, current) => prev * current);
                    break;
                }
                case "multiply-first": {
                    if (values.length > 1) {
                        let first = values.shift();
                        let others = values.reduce((prev, current) => prev + current);
                        thisGroup.value = first * others;
                    } else {
                        thisGroup.value = 0;
                    }

                    break;
                }
                case "divide": {
                    thisGroup.value = values.reduce((prev, current) => prev / current);
                    break;
                }
            }
            console.log(thisGroup.value);
        }

        thisGroup.type = type;
        thisGroup.total = total;
        thisGroup.element = group[0];

        let inputs = group.find(".wp-block-lg-blocks-longevity-calculator-input__input");

        thisGroup.inputs = [];

        inputs.each(function (eindex) {
            let input = $(this);
            thisGroup.inputs[eindex] = {};
            let thisInput = thisGroup.inputs[eindex];


            thisInput.validate = () => {
                console.log("input validation called!");
                var validates = true;
                if (!isFinite(thisInput.value) || thisInput.value < 0) {
                    thisInput.error = "Value must be greater than 0."
                    validates = false;
                }
                if (!thisInput.touched || thisInput.value == - undefined) {
                    thisInput.error = "This field is required."
                    validates = false;
                }

                if (validates === true) {
                    input.removeClass("error");
                    input.parent().find(".error-message").remove();
                    return true
                } else {
                    input.addClass("error");
                    if (input.parent().find(".error-message").length === 0) {
                        input.parent().append(`<span class="error-message"> ${thisInput.error} </span>`)
                    }
                    return false;
                }
            }


            thisInput.element = input;
            thisInput.value = 0;
            thisInput.touched = false;
            if (input.parent().hasClass("wp-block-lg-blocks-longevity-calculator-input-select")) {
                thisInput.touched = true;
            }
            if (input.val() !== undefined && input.val() !== '') {
                thisInput.value = parseFloat(this.value);
            }
            this.addEventListener("change", (e) => {
                thisInput.value = parseFloat(e.target.value);
                thisInput.touched = true;
                thisInput.validate();
                thisCalculator.calculateGroups();
            })
            if (this.id.includes("clone")) {
                let search = this.id.slice(0, -6);
                if ($(`#${search}`).val() !== undefined) {
                    this.value = parseFloat($(`#${search}`).val());
                    thisInput.value = parseFloat($(`#${search}`).val());
                    thisInput.touched = true;
                }
                $(`#${search}`).on("change", (e) => {
                    console.log(`Hidden field updated to ${e.target.value}!`);
                    console.log(thisInput);
                    this.value = parseFloat(e.target.value);
                    thisInput.value = parseFloat(e.target.value);
                    thisInput.touched = true;

                })
            }
            this.addEventListener("blur", thisInput.validate);
        })
    })

    let slides = calculator.find(".wp-block-lg-blocks-longevity-calculator-slide");
    thisCalculator.slides = [];

    thisCalculator.validateSlide = (thisSlide) => {
        console.log("Validate Slide Called!");
        let results = thisSlide.inputs.map(input => { return input.validate() })
        console.log(results);
        if (results.includes(false)) {
            return false;
        }
        return true;

    }

    thisCalculator.slideNext = (thisSlide) => {
        console.log("Slide Next Called!");
        let current = $(thisCalculator.activeSlide.element);
        let currIndex = thisCalculator.activeSlide.index;

        let validates = thisCalculator.validateSlide(thisSlide);

        if (validates) {
            if (currIndex >= 0 && currIndex < thisCalculator.slides.length - 1) {
                current.next().addClass("show").removeClass("hide").siblings().removeClass("show").addClass("hide");
                thisCalculator.activeSlide = thisCalculator.slides[currIndex + 1];

            }
            if (currIndex === thisCalculator.slides.length - 1) {
                thisCalculator.slideTo(0);
            }
        }

    }

    thisCalculator.slideBack = () => {
        console.log("Slide Back Called!");
        let current = $(thisCalculator.activeSlide.element);
        let currIndex = thisCalculator.activeSlide.index;

        if (currIndex > 0) {
            current.prev().addClass("show").removeClass("hide").siblings().removeClass("show").addClass("hide");
            thisCalculator.activeSlide = thisCalculator.slides[currIndex - 1]
        }
    }

    thisCalculator.slideTo = (index) => {
        console.log("Slide To Called!");
        let currIndex = thisCalculator.activeSlide.index;
        if (index < 0 || index > thisCalculator.slides.length) {
            console.error("Cannot Slide to a non-existent slide. Check index and try again.");
            return;
        }
        if (index < currIndex) {
            thisCalculator.activeSlide = thisCalculator.slides[index];
            let current = $(thisCalculator.activeSlide.element);
            current.addClass("show").removeClass("hide").siblings().removeClass("show").addClass("hide");
        } else {
            console.warn("Cannot Slide to a slide with a greater index than current slide. Check index and try again.");
        }

    }


    slides.each(function (sindex) {
        let slide = $(this);

        thisCalculator.slides[sindex] = {};
        let thisSlide = thisCalculator.slides[sindex];
        thisSlide.index = sindex;
        thisSlide.element = slide[0];

        thisSlide.backEl = slide.find(".slide-back")[0];
        thisSlide.nextEl = slide.find(".slide-next")[0];

        thisSlide.backEl.addEventListener("click", thisCalculator.slideBack);
        thisSlide.nextEl.addEventListener("click", () => { thisCalculator.slideNext(thisSlide) });

        let slideLinks = slide.find(".slide-label");

        slideLinks.each(function (slindex) {
            let link = $(this);
            let selIndex = link.data("id");

            link.on("click", () => {
                console.log(selIndex);
                thisCalculator.slideTo(selIndex);
            })

        })

        thisSlide.inputs = [];
        let slideGroups = slide.find(".wp-block-lg-blocks-longevity-calculator-group");

        slideGroups.each(function (sgindex) {
            thisCalculator.groups.forEach(group => {
                if (isEqual(this, group.element)) {
                    group.inputs.forEach(input => {
                        thisSlide.inputs.push(input)
                    });
                }
            });
        })






    })

    thisCalculator.activeSlide = thisCalculator.slides[0];


})